import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  { path: "/log-in", component: () => import("./views/LogIn.vue") },
  {
    path: "/register",
    redirect: "/log-in",
    // component: () => import("./views/Registration.vue"),
  },
  {
    path: "/restore-password",
    component: () => import("./views/ForgotPassword.vue"),
  },
  {
    path: "/verify-email",
    component: () => import("./views/EmailVerification.vue"),
  },
  {
    path: "/reset-password",
    component: () => import("./views/PasswordReset.vue"),
  },
  {
    path: "/error/404",
    component: () => import("./views/Error404.vue"),
  },
  {
    path: "/error/ooops",
    component: () => import("./views/Ooops.vue"),
  },
  {
    path: "/error/:code(.+)",
    component: () => import("./views/Error500.vue"),
  },
  {
    path: "/:path(.*)",
    redirect: "/log-in",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
